export interface FeatureFlagResponse {
  feature_flags: FeatureFlagType[]
  status: string
}

export interface FeatureFlagType {
  id: number
  name: string
  description: string
  flag: boolean
}

export class FeatureFlag implements FeatureFlagResponse {
  status: string = 'loading'
  feature_flags: FeatureFlagType[] = []

  static async getFeatureFlags(cookie: string): Promise<FeatureFlagResponse> {
    try {
      const response = await fetch(`${process.env.API_URL}/feature_flags`, {
        method: 'GET',
        signal: AbortSignal.timeout(5000),
        headers: {
          Cookie: cookie,
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      if (!response.ok) {
        console.log('Request Failed')
      }

      const res: FeatureFlagResponse = await response.json()
      return res
    } catch (error) {
      return {
        status: 'error',
        feature_flags: [],
      }
    }
  }

  static getCaptchaType = (featureFlags: FeatureFlagType[] = []) => {
    const cType =
      featureFlags?.find((item) => item?.name === 'hcaptcha')?.flag === true
        ? 'hCaptcha'
        : 'reCaptcha'

    return cType
  }

  static getNeedCaptcha = (featureFlags: FeatureFlagType[] = []): boolean => {
    const captchaNeeded: boolean =
      featureFlags?.find((item) => item?.name === 'captcha')?.flag ?? false

    return captchaNeeded
  }
}
